import { createContext } from 'react';

export const ColorSwatchingContext = createContext();
